import { QAEventInfo } from "sb-resp-lib";
import { QALiveSlipSelection } from "../QALiveSlipSelection";
import { observable } from "mobx";

export class QAEventInfoExt extends QAEventInfo {

    @observable spLines: QALiveSlipSelection[];

    constructor(source: QAEventInfo) {
        super(source);
        this.spLines = [];
    }
}